import { useEffect } from "react";
import { useSelector } from "react-redux";

import { ShoppingCartSummary } from "@/components/Cart/ShoppingCartSummary/shoppingCartSummary.component";
import { Spinner } from "@/components/General/Spinner/spinner.component";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CartSelectors from "@/redux/modules/api/data/cart/cart.selectors";
import * as StoreDetailsModule from "@/redux/modules/api/data/stores/storeDetails/storeDetails.module";
import * as StoreDetailsSelectors from "@/redux/modules/api/data/stores/storeDetails/storeDetails.selectors";
import { Config } from "@/utils/config.utils";

const ShoppingCartOverviewContainer = () => {
    const cart = useSelector(CartSelectors.getCart);
    const isLoadingCart = useSelector(CartSelectors.isLoading);
    const cartError = useSelector(CartSelectors.getCartError);
    const storeDetails = useSelector(StoreDetailsSelectors.getStoreDetails);
    const dispatch = useThunkDispatch();

    useEffect(() => {
        if (
            cartError?.error.response.status === 400 &&
            !window.location.href.includes(Config.pages.cart)
        ) {
            window.location.href = Config.pages.cart;
        }
    }, [cartError]);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (cart?.storeId) {
            dispatch(StoreDetailsModule.load(cart.storeId));
        }
    }, [cart?.storeId]);

    const cartKey = cart?.items.map((item) => item.id).join(",") ?? "";

    return (
        <>
            {isLoadingCart && !cart && <Spinner />}
            {(!isLoadingCart || cart) && (
                <ShoppingCartSummary
                    key={cartKey}
                    storeDetails={storeDetails}
                    shoppingCart={cart}
                />
            )}
        </>
    );
};

export { ShoppingCartOverviewContainer };
